// extracted by mini-css-extract-plugin
export default {"p-inputgroup":"Form_p-inputgroup__NPNkq","active":"Form_active__Y-cPr","invalid":"Form_invalid__K2pTF"};